import { ToastContainer } from 'react-toastify';

import { darken } from 'polished';
import styled from 'styled-components';

export const AppContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'Saira Semi Condensed', sans-serif !important;
    span {
        font-family: 'Saira Semi Condensed', sans-serif !important;
    }

    @media (max-width: 800px) {
        .time {
            font-size: max(24px, 4.5vh) !important;
        }
        .title {
            font-size: max(14px, 2.2vh) !important;
        }
        .info {
            font-size: max(14px, 2.2vh) !important;
        }
        .info span[style] {
            font-size: max(24px, 3.5vh) !important;
        }
        .big-value {
            font-size: max(20px, 3.5vh) !important;
        }
        .card-title {
            font-size: max(14px, 2.2vh) !important;
        }
        .info-title {
            font-size: max(14px, 2.2vh) !important;
        }
        .info-value {
            font-size: max(16px, 2.5vh) !important;
        }
        .row-ellipsis {
            font-size: max(14px, 2vh) !important;
        }
        .status {
            margin-bottom: max(8px, 1vh) !important;
            margin-top: max(2px, 0.5vh) !important;
        }
        .status .title {
            font-size: max(14px, 2vh) !important;
        }
        .status span {
            font-size: max(14px, 2vh) !important;
        }
        .MuiTableCell-root,
        .MuiTableCell-head {
            font-size: max(14px, 2vh) !important;
        }
        .MuiButton-label {
            font-size: max(14px, 2vh) !important;
        }
        .MuiBadge-root {
            margin-right: max(6px, 1vw) !important;
        }
        span {
            font-size: max(12px, 1.8vh);
        }
    }
`;

export const Splash = styled.div`
    display: flex;
    padding: 0px;
    margin: 0px;
    background: ${props => props.theme.palette.primary.main};
    width: 100%;
    height: 100vh;
    z-index: 3000;
    position: absolute;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const Container = styled.div`
    padding: 0px 0px 150px 0px;
    /* background-color: #f00; */
    background: ${props => {
        const color = props.theme.palette.primary.main;
        return `linear-gradient(-45deg, ${darken(0.5, '#000')}, ${darken(
            0.4,
            color
        )})`;
    }};
    height: 100%;
`;

export const Title = styled.div`
    padding: 30px;

    h1 {
        text-align: center;
        color: #fff;
        font-weight: bold;
    }
`;

export const Body = styled.div`
    padding: 0px;
    width: 100%;
    margin: auto;
    min-height: 100vh;
    height: 100vh;
`;

export const NullDiv = styled.div``;

export const RC3ToastContainer = styled(ToastContainer)`
    width: 20vw;
    .Toastify__toast {
        display: block;
    }
    .DARK {
        background-color: #000;
        border-left: 0.5vw solid ${props => props.theme.palette.primary.main};
    }
    .TELEPRESENCE {
        background-color: #000;
        border-left: 0.5vw solid ${props => props.theme.palette.primary.main};
    }
    .INDOOR_DELIVERY {
        background-color: #000;
        border-left: 0.5vw solid ${props => props.theme.palette.primary.main};
    }
`;

export const DarkDialog = styled.div`
    color: #fff !important;
    border-top: 0.5vh solid ${props => props.theme.palette.primary.main};
    border-bottom: 0.5vh solid ${props => props.theme.palette.primary.main};
    background: ${props => {
        const color = props.theme.palette.primary.main;
        return `${darken(0.25, color)}`;
    }};

    .MuiDialogTitle-root {
        h2 {
            font-family: 'Saira Semi Condensed', sans-serif !important;
            color: #fff !important;
        }
    }
`;
